import { orchestrator } from 'satcheljs';
import { viewActivity } from '../actions/viewActivity';
import { logUsage } from 'owa-analytics';

let viewActivityUrl = 'https://go.microsoft.com/fwlink/?linkid=872494';

export default orchestrator(viewActivity, async function viewActivity() {
    logUsage('PremiumDashViewRecentActivityClicked');
    window.open(viewActivityUrl, '_blank');
});
